import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { CurrencyWalletService } from 'src/app/layouts/currency-wallet/currency-wallet.service';
import { AllianceApi } from 'src/app/shared/apis/alliance.api';
import { ReferralRewardInfo } from 'src/app/shared/interfaces/alliance.interface';
import { CurrenciesInterface } from 'src/app/shared/interfaces/deposit.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { appOrWebDomain } from '../../../friend.helper';
import { FriendService } from '../../../friend.service';
export type DialogDataSubmitCallback<T> = (row: T) => void;
@UntilDestroy()
@Component({
  selector: 'app-invite-friends',
  templateUrl: './invite-friends.component.html',
  styleUrls: ['./invite-friends.component.scss'],
})
export class InviteFriendsComponent implements OnInit {
  isH5!: boolean;
  /** 推荐Url */
  referralUrl: string = '';
  rate!: number | undefined;
  rates!: { currency: string; rate: number }[];
  currency!: CurrenciesInterface | null;
  referAFriendReward!: number;
  loading: boolean = true;

  constructor(
    private layout: LayoutService,
    private dialogRef: MatDialogRef<InviteFriendsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { callback: DialogDataSubmitCallback<any>; isSave: boolean },
    public appService: AppService,
    private allianceApi: AllianceApi,
    private currencyWalletService: CurrencyWalletService,
    public friendService: FriendService
  ) {}

  async ngOnInit() {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => (this.isH5 = e));
    this.friendService.getReferralRewardInfo();
    combineLatest([
      this.allianceApi.getDefaultReferralCode(),
      this.currencyWalletService.conversionCurrency$,
      this.friendService.referralRewardInfo$,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([data, v, x]) => {
        if (data?.referralCode) {
          this.referralUrl = `${appOrWebDomain()}/${this.appService.languageCode}?inviteCode=${
            data.referralCode
          }#register`;
        }
        // data.referralCode;
        if (v.enable) {
          this.currency = v.currency;
          this.rate = v.rate.find(cur => cur.currency === 'USDT')?.rate || 1;
        } else {
          this.currency = this.appService.currencies$.value.find(cur => cur.currency === 'USDT') || null;
          this.rate = 1;
        }
        if (!x) return;
        this.referAFriendReward = ((x ?? []) as ReferralRewardInfo[]).reduce((a, b) => {
          return a + Number(b?.reward ?? 0);
        }, 0);
        this.loading = false;
      });
  }

  close() {
    this.dialogRef.close();
    this.layout.leftMenuState$.next(false);
  }
}
